export const isLiability = resource => resource.attr('accountType') === 'liability';

export const refreshAccounts = async (householdResource) => {
  if (householdResource) {
    const accountsCollection = await householdResource
      .relationship('accounts')
      .link('related')
      .Get();

    const realAssetsCollection = await householdResource
      .relationship('realAssets')
      .link('related')
      .Get();

    // TODO: use predefined query for investmentAssets/liabilities to populate lists here.
    // Needs changes to Facet Rest to support Get() on a query
    // const query = accountsCollection.meta().query('liabilities');

    const l = accountsCollection
      .resources()
      .list()
      .filter(acc => isLiability(acc))
      .sort((a, b) => (a.attr('type') > b.attr('type') ? 1 : -1));

    const ia = accountsCollection
      .resources()
      .list()
      .filter(acc => !isLiability(acc))
      .sort((a, b) => (a.attr('accountType') > b.attr('accountType') ? 1 : -1));
    const ra = realAssetsCollection
      .resources()
      .list()
      .map(asset => asset.attr('accountType', asset.attr('type')))
      .map(asset => asset.attr('type', 'realAsset'));

    return {
      liabilities: l,
      investmentAssets: ia,
      realAssets: ra,
    };
  }
  return null;
};
